(function () {
  function initializeAccessibilityTools() {
    document.querySelectorAll('[data-bpc-a11y-v2]').forEach(function (widget) {
      if (widget.dataset.initialized === 'true') return;
      widget.dataset.initialized = 'true';

      var root = document.documentElement;
      var storageKey = 'bpc-accessibility-preferences';
      var controls = Array.from(widget.querySelectorAll('[data-a11y-pref]'));
      var status = widget.querySelector('[data-a11y-status]');
      var textSize = widget.querySelector('[data-a11y-text-size]');
      var textOutput = widget.querySelector('[data-a11y-text-output]');
      var launchButton = widget.querySelector('[data-a11y-v2-launch]');
      var panel = widget.querySelector('.bpc-a11y__panel');
      var closeButton = widget.querySelector('[data-a11y-close]');
      var preferences = {};

      try {
        preferences = JSON.parse(localStorage.getItem(storageKey) || '{}');
      } catch (error) {
        preferences = {};
      }

      function announce(message) {
        if (status) status.textContent = message;
      }

      function classFor(preference) {
        return 'bpc-a11y-' + preference;
      }

      var textLevels = [
        { label: 'Default', scale: 1 },
        { label: 'Large 112%', scale: 1.125 },
        { label: 'Larger 125%', scale: 1.25 },
        { label: 'Extra large 138%', scale: 1.375 },
        { label: 'Maximum 150%', scale: 1.5 }
      ];

      function captureFontSizes(scope) {
        var elements = [];
        if (scope.nodeType === 1) elements.push(scope);
        if (scope.querySelectorAll) elements = elements.concat(Array.from(scope.querySelectorAll('*')));
        var candidates = elements.filter(function (element) {
          if (!(element instanceof HTMLElement) || element.closest('.bpc-a11y') || element.dataset.bpcBaseFont) return false;
          var hasDirectText = Array.from(element.childNodes).some(function (node) {
            return node.nodeType === 3 && node.textContent.trim();
          });
          var isTextControl = ['INPUT', 'TEXTAREA', 'SELECT', 'OPTION', 'BUTTON'].indexOf(element.tagName) !== -1;
          return hasDirectText || isTextControl;
        });
        var activeScale = root.classList.contains('bpc-a11y-text-scale') ? parseFloat(root.style.getPropertyValue('--bpc-text-scale')) || 1 : 1;
        var measurements = candidates.map(function (element) {
          return { element: element, size: parseFloat(window.getComputedStyle(element).fontSize) / activeScale };
        });
        measurements.forEach(function (measurement) {
          if (!(measurement.size > 0)) return;
          measurement.element.dataset.bpcBaseFont = 'true';
          measurement.element.style.setProperty('--bpc-base-font-size', measurement.size + 'px');
        });
      }

      function applyTextSize() {
        var level = Number(preferences.textScale || 0);
        if (!Number.isInteger(level) || level < 0 || level >= textLevels.length) level = 0;
        var setting = textLevels[level];
        root.classList.toggle('bpc-a11y-text-scale', level > 0);
        root.style.setProperty('--bpc-text-scale', String(setting.scale));
        if (textSize) {
          textSize.value = String(level);
          textSize.setAttribute('aria-valuetext', setting.label);
        }
        if (textOutput) textOutput.textContent = setting.label;
      }

      function apply() {
        applyTextSize();
        controls.forEach(function (control) {
          var preference = control.dataset.a11yPref;
          var active = preferences[preference] === true;
          root.classList.toggle(classFor(preference), active);
          control.setAttribute('aria-pressed', String(active));
        });
        localStorage.setItem(storageKey, JSON.stringify(preferences));
      }

      if (preferences.text === true && preferences.textScale === undefined) preferences.textScale = 1;
      delete preferences.text;
      captureFontSizes(document.body);

      if (textSize) {
        textSize.addEventListener('input', function () {
          preferences.textScale = Number(textSize.value);
          apply();
          announce('Text size ' + textLevels[preferences.textScale].label);
        });
      }

      if (launchButton && panel) {
        function setPanelOpen(open, returnFocus) {
          panel.hidden = !open;
          panel.setAttribute('aria-hidden', String(!open));
          launchButton.setAttribute('aria-expanded', String(open));
          if (open && closeButton) closeButton.focus();
          if (!open && returnFocus) launchButton.focus();
        }

        window.addEventListener('click', function (event) {
          var requestedLauncher = event.target.closest && event.target.closest('[data-a11y-v2-launch]');
          if (requestedLauncher !== launchButton) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          captureFontSizes(document.body);
          setPanelOpen(panel.hidden, false);
        }, true);

        if (closeButton) {
          closeButton.addEventListener('click', function () {
            setPanelOpen(false, true);
          });
        }

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && !panel.hidden) setPanelOpen(false, true);
        });
      }

      controls.forEach(function (control) {
        control.addEventListener('click', function () {
          var preference = control.dataset.a11yPref;
          preferences[preference] = preferences[preference] !== true;
          apply();
          announce(control.textContent.trim() + ' ' + (preferences[preference] ? 'on' : 'off'));
        });
      });

      var resetButton = widget.querySelector('[data-a11y-reset]');
      if (resetButton) {
        resetButton.addEventListener('click', function () {
          preferences = {};
          apply();
          announce('Accessibility preferences reset');
        });
      }

      apply();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAccessibilityTools);
  } else {
    initializeAccessibilityTools();
  }

  document.addEventListener('shopify:section:load', initializeAccessibilityTools);
}());
